import { html, ref, when } from '@microsoft/fast-element';
import type { ViewTemplate } from '@microsoft/fast-element';
import type { Companys } from './company';

export const CompanysTemplate: ViewTemplate = html<Companys>`
  ${when(
    (x) => x.isAdmin,
    html<Companys>`
      <zero-button appearance="primary" class="link-advisors" @click=${(x) => x.openLinkAdvisors()}>
        Assign Advisors
      </zero-button>
      <zero-button appearance="primary" class="create-company" @click=${(x) => x.createCompany()}>
        Add
      </zero-button>
    `,
  )}

  <entity-management
    ${ref('companyEntityElm')}
    resourceName=${(x) => x.resourceName}
    title="Company Management"
    entityLabel="Company"
    updateEvent="EVENT_COMPANY_UPDATE"
    modal-position="centre"
    :columns=${(x) => [...x.columns]}
    :datasourceConfig=${(x) => x.datasourceConfig}
    :permissions=${(x) => x.permissions}
    :gridOptions=${(x) => x.gridOptions}
  >
    <edit-company slot="edit" :isEditable=${(x) => x.isEditable}></edit-company>
  </entity-management>

  ${when(
    (x) => x.linkAdvisors,
    html<Companys>`
      <link-advisors @close="${(x) => (x.linkAdvisors = false)}"></link-advisors>
    `,
  )}
`;
